import { render, staticRenderFns } from "./MixItemFeed.vue?vue&type=template&id=60b6243e&scoped=true&"
import script from "./MixItemFeed.vue?vue&type=script&lang=js&"
export * from "./MixItemFeed.vue?vue&type=script&lang=js&"
import style0 from "./MixItemFeed.vue?vue&type=style&index=0&id=60b6243e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6243e",
  null
  
)

export default component.exports